<template lang="pug">
.v-detail-page.detail-page(v-if="data")
	.detail-page__header(v-if="data?.type === 'new-build' || data?.type === 'shop' || data?.type === 'sale' ||  data?.type === 'services-company'")
		.container
			.detail-page__actions
				.detail-page__actions-wrap
					.detail-page__date(v-if="data.mobileDate && isSm" ) {{ data.mobileDate }}
					.detail-page__date(v-else-if="data.date" ) {{ data.date }}
				.detail-page__actions-wrap
					template(v-if="data.buttons" )
						button.detail-page__actions-btn(v-for="(button, index) in data.buttons" :key="index" @click="buttonEvent(button.event, data.notification)")
							v-svg-icon.detail-page__actions-icon(v-if="button.icon" :icon="button.icon")
							.detail-page__actions-value(v-if="button.value" ) {{ button.value }}&nbsp;
							.detail-page__actions-text(v-if="button.text && !isSm" ) {{ button.text }}
					v-favorite-action.top(:id="data.id"
						:name="data.title?.text"
						:favorite="data.favorite")
				.detail-page__actions-nav
					a.detail-page__actions-nav-btn(:class="{'disabled': !data.navPrev}" :href="data.navPrev?.href || '#'" @click="!data.navPrev && $event.preventDefault()" aria-label="Предыдущий объект")
						v-svg-icon(icon="arrow-left")
					a.detail-page__actions-nav-btn(:class="{'disabled': !data.navNext}" :href="data.navNext?.href || '#'" @click="!data.navNext && $event.preventDefault()" aria-label="Следующий объект")
						v-svg-icon(icon="arrow-forward")
			.detail-page__name
				.detail-page__id.h1(v-if="data.id && !isSm" ) ID: {{ data.id }}
				h1.detail-page__title(v-if="data.title" )
					.title__text(v-if="data.title.text" ) {{ data.title.text }}
					.title__value(v-if="data.title.value" ) {{ data.title.value }}
					.title__postfix(v-if="data.title.postfix" ) {{ data.title.postfix }}
			.detail-page__location
				.detail-page__id.detail-page__id--mobile.h1(v-if="data.id && isSm" ) ID: {{ data.id }}
				.location(v-if="data.location" )
					v-svg-icon.location-icon(v-if="data.location.icon" :icon="data.location.icon")
					span.location-region(v-if="data.location.region" ) {{ data.location.region }}
					span.location-district(v-if="data.location.district" ) , {{ data.location.district }}
	.detail-page__slider(v-if="data?.type === 'new-build' && !isSm || data?.type === 'shop' && !isSm || data?.type === 'sale' && !isSm ||  data?.type === 'services-company' && !isSm" )
		.detail-page__slider-background
			.container
				v-image-slider-horizontal(:data-source="data.slider" @open-gallery="showGallery")
	.detail-page__slider(v-if="data?.type === 'new-build' && isSm || data?.type === 'shop' && isSm || data?.type === 'sale' && isSm ||  data?.type === 'services-company' && isSm" )
		.container
			v-image-slider-vertical(:data-source="data.slider" @open-gallery="showGallery")
	.container
		.detail-page__main
			.detail-page__article
				.detail-page__status(v-if="isLg && data?.type !== 'rent' && data.aside?.status?.length")
					v-status.status--mobile(:status="data.aside.status")
				.detail-page__wrap(v-if="data?.type === 'rent' || data?.type === 'services-private'")
					.detail-page__actions
						.detail-page__actions-wrap
							.detail-page__date(v-if="data.mobileDate && isSm" ) {{ data.mobileDate }}
							.detail-page__date(v-else-if="data.date" ) {{ data.date }}
						.detail-page__actions-wrap
							template(v-if="data.buttons" )
								button.detail-page__actions-btn(v-for="(button, index) in data.buttons" :key="index" @click="buttonEvent(button.event, data.notification)")
									v-svg-icon.detail-page__actions-icon(v-if="button.icon" :icon="button.icon")
									.detail-page__actions-value(v-if="button.value" ) {{ button.value }}&nbsp;
									.detail-page__actions-text(v-if="button.text && !isSm" ) {{ button.text }}
							v-favorite-action.top(:id="data.id"
								:name="data.title?.text"
								:favorite="data.favorite")
						.detail-page__actions-nav
							a.detail-page__actions-nav-btn(:class="{'disabled': !data.navPrev}" :href="data.navPrev?.href || '#'" @click="!data.navPrev && $event.preventDefault()" aria-label="Предыдущий объект")
								v-svg-icon(icon="arrow-left")
							a.detail-page__actions-nav-btn(:class="{'disabled': !data.navNext}" :href="data.navNext?.href || '#'" @click="!data.navNext && $event.preventDefault()" aria-label="Следующий объект")
								v-svg-icon(icon="arrow-forward")

					.detail-page__header(:class="{'border-none': data?.type === 'services-private'}")
						.detail-page__status.detail-page__status--frame(v-if="isLg && data?.type === 'rent' && data.aside?.status?.length")
							v-status.status--mobile(:status="data.aside.status")
						.detail-page__name
							.detail-page__id.h1(v-if="data.id && !isSm" ) ID: {{ data.id }}
							h1.detail-page__title(v-if="data.title" )
								.title__text(v-if="data.title.text" ) {{ data.title.text }}
								.title__value(v-if="data.title.value" ) {{ data.title.value }}
								.title__postfix(v-if="data.title.postfix" ) {{ data.title.postfix }}
						.detail-page__location
							.detail-page__id.detail-page__id--mobile.h1(v-if="data.id && isSm" ) ID: {{ data.id }}
							.location(v-if="data.location" )
								v-svg-icon.location-icon(v-if="data.location.icon" :icon="data.location.icon")
								span.location-region(v-if="data.location.region" ) {{ data.location.region }}
								span.location-district(v-if="data.location.district" ) , {{ data.location.district }}
					.detail-page__slider(v-if=" data?.type !== 'services-private'" )
						v-image-slider-vertical(:data-source="data.slider" @open-gallery="showGallery")
					.detail-page__slider--small(v-if="data?.type === 'services-private' && isMobile" )
						v-image-slider-vertical(:data-source="data.slider" @open-gallery="showGallery")
				.detail-page__slider-content(v-if="data.sliderContent && data?.type !== 'services-private'" )
					.slider-content__info(v-for="(item, index) in data.sliderContent" :key="index")
						.slider-content__text(v-if="item.text" :class="{'empty': item?.value === 0}") {{ item.text }}
						.slider-content__value(v-if="item.value || item.value === 0" :class="{'empty': item?.value === 0}") &nbsp;{{ item.value }}
				template(v-if="data.blocks" )
					.detail-section(v-for="(block, index) in data.blocks" :key="index" :class="{'hidden': !isSm && block.about}")

						h2.detail-section__title(v-if="block.title" ) {{ block.title }}
						.detail-section__block.info-items(v-if="block.items" )
							.info-items__item(v-for="(item, index) in block.items" :key="index" :style="{width: item.width || null}")
								span.info-items__title(v-if="item.title" ) {{ item.title }}
								.info-items__block
									.info-items__value-arrow(v-if="item.value && Array.isArray(item.value)" )
										template(v-for="(link, index) in item.value" :key="index")
											a.info-items__value-link(v-if="link.href" :href="link.href" :target="link?.target")
												img.info-items__value-image(
													v-if="link.image"
													:src="link.image?.src"
													:alt="link.image?.alt")
									a.info-items__value.info-items__value--link(v-else-if="item.value && item.href" :href="item.href" target="_blank" rel="noopener noreferrer") {{ item.value }}
									span.info-items__value(v-else-if="item.value" ) {{ item.value }}
									span.info-items__postfix(v-if="item.postfix" ) &nbsp;{{ item.postfix }}
						.detail-section__about(v-if="isSm && block.about" )
							a.detail-section__about-logo(:href="block.about.href || '#'")
								img.detail-section__about-logo-img(v-if="block.about.image" :src="block.about.image.src" :alt="block.about.image.alt")
							.detail-section__about-group
								.detail-section__text(v-if="block.about.title") {{ block.about.title }}
								.detail-section__text--gray(v-if="block.about.subtitle") {{ block.about.subtitle }}
							.detail-section__about-owner(v-if="block.about.owner" )
								img.detail-section__about-owner-img(v-if="block.about.owner.image" :src="block.about.owner.image.src" :alt="block.about.owner.image.alt")
								.detail-section__group
									.detail-section__about-owner-name(v-if="block.about.owner.name") {{ block.about.owner.name }}
									.detail-section__about-owner-position(v-if="block.about.owner.position") {{ block.about.owner.position }}
							.detail-section__about-buttons(v-if="block.about.buttons" )
								button.detail-section__about-button(v-for="(button, index) in block.about.buttons"
									:key="index"
									:type="button.type"
									:class="button.class"
									@click="button.event ? isNumberVisible = true : null")
									a.product-t-list__owner-contact-link(v-if="isNumberVisible"
										:href="`tel:${button.hiddenText}`")
										| {{ button.hiddenText }}
									span(v-else) {{ button.text }}
						.detail-section__social(v-if="block.links")
							a(v-for="(link, index) in block.links" :key="index" :href="link?.href" :target="link?.target")
								v-svg-icon.detail-section__social-icon(:icon="link.icon")
						.detail-section__subblock(v-if="block.detail")
							//.detail-section__separator.separator-x
							template(v-if="block.detail.items" )
								.subblock__item.flc(v-for="(item, index) in block.detail.items" :key="index")
									.subblock__item-title(v-if="item.title" ) {{ item.title }}
									.subblock__price-current(v-if="item.price?.current" )
										span.subblock__price-prefix(v-if="item.price.current.prefix" ) {{ item.price.current.prefix }}&nbsp;
										span.subblock__price-currency(v-if="item.price.current.currency" ) {{ item.price.current.currency }}&nbsp;
										span.subblock__price-value(v-if="item.price.current.value" ) {{ formatInteger(item.price.current.value) }}
							template(v-if="block.detail.schedule" )
								.schedule
									.schedule__table(v-for="(table,index) in block.detail.schedule" :key="index" :style="{width: table.width || null}")
										.schedule__head(v-if="table.scheduleHead" )
											.schedule__title(v-for="(head, index) in table.scheduleHead" :key="index") {{ head?.title }}
										.schedule__body(v-if="table.scheduleRows" )
											.schedule__row(v-for="(row, index) in table.scheduleRows" :key="index")
												.schedule__column-first
													.schedule__day(v-if="row.day" ) {{ row.day }}
													.schedule__work-time(v-if="row.workTime" ) {{ row.workTime }}
												.schedule__column-second(v-if="row.breakTine")
													.schedule__break-time( ) {{ row.breakTine }}


						v-read-more(v-if="block.content" :content="block.content" :more-text="block.showMore" :less-text="block.showLess")
						template(v-if="block.tabs && block.tabs.length")
							v-tabs(:data-source="{tabs: block.tabs, type: 'slots'}")
								template(#tab_0="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
											.detail-section__row-title(v-if="item.title" ) {{ item.title }}
											.detail-section__row-value(v-if="item.value" ) {{ item.value }}
											a.detail-section__section-button(v-if="item.link" download :href="item.link.href")
												v-svg-icon.detail-section__section-button-icon(v-if="item.link.icon" :icon="item.link.icon")
												.detail-section__section-button-text(v-if="item.link.text") {{ item.link.text }}
								template(#tab_1="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
											.detail-section__row-title(v-if="item.title" ) {{ item.title }}
											.detail-section__row-value(v-if="item.value" ) {{ item.value }}
											a.detail-section__section-button(v-if="item.link" download :href="item.link.href")
												v-svg-icon.detail-section__section-button-icon(v-if="item.link.icon" :icon="item.link.icon")
												.detail-section__section-button-text(v-if="item.link.text") {{ item.link.text }}
								template(#tab_2="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
											.detail-section__row-title(v-if="item.title" ) {{ item.title }}
											.detail-section__row-value(v-if="item.value" ) {{ item.value }}
											a.detail-section__section-button(v-if="item.link" download :href="item.link.href")
												v-svg-icon.detail-section__section-button-icon(v-if="item.link.icon" :icon="item.link.icon")
												.detail-section__section-button-text(v-if="item.link.text") {{ item.link.text }}
						template(v-if="block.tabsColumn && block.tabsColumn.length")
							v-tabs(:data-source="{tabs: block.tabsColumn, type: 'slots'}")
								template(#tab_0="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__table
											.detail-section__table-head
												.detail-section__table-item(v-for="(head, index) in slotProps.content.columns" :key="index") {{ head.title }}
											.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
												.detail-section__row-title(v-if="item.bedroom" ) {{ item.bedroom }}
												.detail-section__row-value(v-if="item.square" ) {{ computedSquare(item.square) }}
												.detail-section__row-value(v-if="item.price" ) {{ computedPrice(item.price) }}
										.detail-section__notes(v-if="slotProps.content.notes" )
											.detail-section__note(v-for="(item, index) in slotProps.content.notes" :key="index")
												v-svg-icon.detail-section__note-icon(v-if="item.icon" :icon="item.icon")
												.detail-section__note-text(v-if="item.text" ) {{ item.text }}
								template(#tab_1="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__table
											.detail-section__table-head
												.detail-section__table-item(v-for="(head, index) in slotProps.content.columns" :key="index") {{ head.title }}
											.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
												.detail-section__row-title(v-if="item.bedroom" ) {{ item.bedroom }}
												.detail-section__row-value(v-if="item.square" ) {{ computedSquare(item.square) }}
												.detail-section__row-value(v-if="item.price" ) {{ computedPrice(item.price) }}
										.detail-section__notes(v-if="slotProps.content.notes" )
											.detail-section__note(v-for="(item, index) in slotProps.content.notes" :key="index")
												v-svg-icon.detail-section__note-icon(v-if="item.icon" :icon="item.icon")
												.detail-section__note-text(v-if="item.text" ) {{ item.text }}
								template(#tab_2="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__table
											.detail-section__table-head
												.detail-section__table-item(v-for="(head, index) in slotProps.content.columns" :key="index") {{ head.title }}
											.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
												.detail-section__row-title(v-if="item.bedroom" ) {{ item.bedroom }}
												.detail-section__row-value(v-if="item.square" ) {{ computedSquare(item.square) }}
												.detail-section__row-value(v-if="item.price" ) {{ computedPrice(item.price) }}
										.detail-section__notes(v-if="slotProps.content.notes" )
											.detail-section__note(v-for="(item, index) in slotProps.content.notes" :key="index")
												v-svg-icon.detail-section__note-icon(v-if="item.icon" :icon="item.icon")
												.detail-section__note-text(v-if="item.text" ) {{ item.text }}
								template(#tab_3="slotProps")
									template(v-if="slotProps.content" )
										.detail-section__table
											.detail-section__table-head
												.detail-section__table-item(v-for="(head, index) in slotProps.content.columns" :key="index") {{ head.title }}
											.detail-section__row(v-for="(item, index) in slotProps.content.items" :key="index")
												.detail-section__row-title(v-if="item.bedroom" ) {{ item.bedroom }}
												.detail-section__row-title(v-if="item.floor" ) {{ item.floor }}
												.detail-section__row-value(v-if="item.square" ) {{ computedSquare(item.square) }}
												.detail-section__row-value(v-if="item.price" ) {{ computedPrice(item.price) }}
										.detail-section__notes(v-if="slotProps.content.notes" )
											.detail-section__note(v-for="(item, index) in slotProps.content.notes" :key="index")
												v-svg-icon.detail-section__note-icon(v-if="item.icon" :icon="item.icon")
												.detail-section__note-text(v-if="item.text" ) {{ item.text }}


						//.detail-section(v-if="data.features" )
						//	h2.detail-section__title(v-if="data.features.title" ) {{ data.features.title }}
						//	template(v-if="data.features.items" )
						//		.features-block.flc(v-for="(block, index) in data.features.items" :key="index")
						//			.features-block__title(v-if="block.title" ) {{ block.title }}
						//			.features-block(v-if="block.items" )
						//				.features-block__item(v-for="(item, index) in block.items" :key="index" :style="{width: item.width || null}")
						//					.features-block__item-text(v-if="item.text" ) {{ item.text }}
						//					v-svg-icon.features-block__item-icon(v-if="item.icon" :icon="item.icon")
				.detail-section.detail-section__property.property(v-if="data.typeProperty" )
					h2.detail-section__title(v-if="data.typeProperty.title" ) {{ data.typeProperty.title }}
					.property__header(v-if="data.typeProperty.headerItems" )
						.property__header-item(
								v-for="(item, index) in data.typeProperty.headerItems"
								:key="index" )
							.property__header-text(v-if="item.text" ) {{ item.text }}
					.property__body
						.property__body-item.flc(
								v-for="(item, index) in data.typeProperty.bodyItems"
								:key="index" )
							.property__body-title(v-if="item.title" ) {{ item.title }}
							.property__body-text(v-if="item.text" ) {{ item.text }}
							v-price.property__body-price(v-if="item.price" :price="item.price")
				.help-block(v-if="data.help" )
					.help-block__wrap
						v-svg-icon.help-block__icon(v-if="data.help.icon" :icon="data.help.icon")
						.help-block__inner
							.help-block__title(v-if="data.help.title" ) {{ data.help.title }}
							.help-block__text(v-if="data.help.text" v-html="data.help.text" )
					a.help-block__button(v-if="data.help.link" :href="data.help.link?.href || '#'" :class="data.help.link?.className") {{ data.help.link?.text }}

				.detail-section__map(v-if="data.map" )
					.detail-section__map-head
						h2.detail-section__title(v-if="data.map.title" ) {{ data.map.title }}
						.location(v-if="data.location" )
							v-svg-icon.location-icon(v-if="data.location.icon" :icon="data.location.icon")
							span.location-region(v-if="data.location.region" ) {{ data.location.region }}
							span.location-district(v-if="data.location.district" ) , {{ data.location.district }}
					v-map-google.detail-section__map-block(
						:initParams="data.map"
						:items="data")

				.detail-section.detail-section__about(v-if="data.about && !isSm")
					a.detail-section__about-logo(:href="data.about.href || '#'")
						img.detail-section__about-logo-img(v-if="data.about.image" :src="data.about.image.src" :alt="data.about.image.alt")
					.detail-section__about-group
						.detail-section__text(v-if="data.about.title") {{ data.about.title }}
						.detail-section__text--gray(v-if="data.about.subtitle") {{ data.about.subtitle }}
					.detail-section__about-owner(v-if="data.about.owner" )
						img.detail-section__about-owner-img(v-if="data.about.owner.image" :src="data.about.owner.image.src" :alt="data.about.owner.image.alt")
						.detail-section__group
							.detail-section__about-owner-name(v-if="data.about.owner.name") {{ data.about.owner.name }}
							.detail-section__about-owner-position(v-if="data.about.owner.position") {{ data.about.owner.position }}
					.detail-section__about-buttons(v-if="data.about.buttons" )
						button.detail-section__about-button(v-for="(button, index) in data.about.buttons"
							:key="index"
							:type="button.type"
							:class="button.class"
							@click="button.event ? isNumberVisible = true : null")
							a.product-t-list__owner-contact-link(v-if="isNumberVisible"
								:href="`tel:${button.hiddenText}`")
								| {{ button.hiddenText }}
							span(v-else) {{ button.text }}

			.detail-page__aside(v-if="data.aside" )
				.aside__slider-content(v-if="data.sliderContent && data?.type === 'services-private'" )
					.slider-content__info(v-for="(item, index) in data.sliderContent" :key="index")
						.slider-content__text(v-if="item.text" :class="{'empty': item?.value === 0}") {{ item.text }}
						.slider-content__value(v-if="item.value || item.value === 0" :class="{'empty': item?.value === 0}") &nbsp;{{ item.value }}
				.aside__slider(v-if="data?.type === 'services-private'" )
					v-small-slider(:data-source="data.slider" @open-gallery="showGallery")
				.aside__status
					v-status(:status="data.aside.status")
				.aside__card
					.aside__price(v-if="data.aside.price" )
						//span.aside__price-prefix(v-if="data.aside.price.text?.from" ) {{ data.aside.price.text?.from }}&nbsp;
						v-price.aside__price-value(:price="data.aside.price")
					.aside__title(v-if="data.aside.title" ) {{ data.aside.title }}
					.aside__info(v-if="data.aside.info" v-html="data.aside.info" )
					.aside__subtitle(v-if="data.aside.subtitle" v-html="data.aside.subtitle")
					a.aside__link(:href="data.aside.href || '#'")
						img.aside__image(v-if="data.aside.image" :src="data.aside.image.src" :alt="data.aside.image.alt")
					.aside__note(v-if="data.aside.note" ) {{ data.aside.note }}
					.aside__owner(v-if="data.aside.owner" )
						img.aside__logo(v-if="data.aside.owner.image" :src="data.aside.owner.image.src" :alt="data.aside.owner.image.alt")
						.aside__owner-group
							.aside__owner-name(v-if="data.aside.owner.name" ) {{ data.aside.owner.name }}
							.aside__owner-position(v-if="data.aside.owner.position" ) {{ data.aside.owner.position }}
					.aside__buttons(v-if="data.aside.buttons" )
						button.aside__button(v-for="(button, index) in data.aside.buttons"
							:key="index"
							:type="button.type"
							:class="button.class"
							@click="button.event ? isNumberVisible = true : null")
							a.product-t-list__owner-contact-link(v-if="isNumberVisible"
								:href="`tel:${button.hiddenText}`")
								| {{ button.hiddenText }}
							span(v-else) {{ button.text }}

				.detail-page__ad(v-if="data.aside.ad" )
					.detail-page__ad-titile(v-if="data.aside.ad.title" ) {{ data.aside.ad.title }}
					.detail-page__ad-block(v-if="data.aside.ad.items" )
						.card-advrtsmnt(v-for="(card, index) in data.aside.ad.items" :key="index" )
							a.card-advrtsmnt__link(v-if="card.link" :href="card.link?.href")
								img.card-advrtsmnt__img(v-if="card.image"
									:src="isMobile ? card.image?.mobileSrc : card.image?.src"
									:alt="card.image?.alt")
	.detail-page__buttom-slider(v-if="data.bottomSlider" )
		.container
			h2.detail-section__title(v-if="data.bottomSlider.title" ) {{ data.bottomSlider.title }}
			v-section-slider(:data-source="data.bottomSlider" template="property" :options="bottomSliderOptions")
	//- Нижний рекламный слайдер. На узких экранах (<= lg-max) CSS прячет правую
	//- колонку вместе с боковым баннером, поэтому там он приезжает сюда первым
	//- слайдом — см. computedAdSlider.
	.detail-page__ad(v-if="computedAdSlider" )
		.container
			v-section-slider(:data-source="computedAdSlider" template="ad" :options="adSliderOptions")
	.slider-gallery(v-if="gallery" )
		.slider-gallery__slider
			v-image-slider-gallery(:data-source="data.slider" @close-gallery="gallery = false" :initial-index="activeIndex")





</template>
<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import breakpoints from "../scripts/breakpoints.js";
import controller from "../scripts/controller/controller.js";
import scrollLock from "scroll-lock";

export default {
	mixins: [
		sourceMixin,
		formattingMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			isNumberVisible: false,
			bottomSliderOptions: {
				slidesPerView: 5,
				spaceBetween: 20,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 5
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 3
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 2
					}
				}
			},
			adSliderOptions: {
				slidesPerView: 4,
				spaceBetween: 15,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 4
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 1
					}
				}
			},
			gallery: false,
			activeIndex: 0,
			isMobile: false
		};
	},

	computed: {
		/**
		 * Данные нижнего рекламного слайдера.
		 *
		 * Боковой баннер (aside.ad) на широких экранах живёт в правой колонке, но
		 * CSS прячет .detail-page__aside при ширине <= lg-max (1439px) — и там он
		 * не показывался вообще нигде. Ниже этой границы подставляем его ПЕРВЫМ
		 * слайдом нижнего слайдера «Advertising». Порог берём тот же, что у CSS
		 * (isLg), иначе на планшетных ширинах баннер снова пропадал бы.
		 *
		 * У баннера есть отдельная мобильная картинка (mobileSrc) — шаблон слайдера
		 * читает только image.src, поэтому подставляем её туда.
		 */
		computedAdSlider() {
			const slider = this.data?.adSlider || null;
			const asideAd = this.data?.aside?.ad || null;
			const asideItems = (this.isLg && asideAd?.items?.length) ? asideAd.items : [];

			if (!asideItems.length) {
				return slider;
			}

			const mobileItems = asideItems.map((item) => ({
				...item,
				image: item.image
					? {...item.image, src: item.image.mobileSrc || item.image.src}
					: item.image
			}));

			return {
				...(slider || {title: asideAd.title}),
				items: [...mobileItems, ...(slider?.items || [])]
			};
		}
	},

	watch: {
		gallery() {
			if(this.gallery) {
				scrollLock.disablePageScroll(document.querySelector('.slider-gallery'));
			} else {
				scrollLock.enablePageScroll(document.querySelector('.slider-gallery'));
			}
		},

		isLg() {
			if(this.isLg) {
				this.isMobile = true
			} else {
				this.isMobile = false
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		buttonEvent(event, notification) {
			switch (event) {
				case 'print':
					window.print();
					break
				case 'share':
					navigator.clipboard.writeText(window.location.href);
					controller.addNotification(notification);
					break
			}
		},

		computedSquare(square) {
			return `${square?.text?.from} ${square?.value?.from} ${square?.text?.to} ${square?.value?.to} ${square?.postfix}`
		},

		computedPrice(price) {
			return this.formatInteger(`${price?.text?.from} ${price?.currency} ${price?.value?.from} ${price?.postfix ? `+ ${price?.postfix}` : '' }`)
		},

		showGallery(index) {
			this.activeIndex = index;
			this.gallery = true
		}
	}

};
</script>
